// src/features/Featured_categories/components/FeaturedCategoriesSkeleton.tsx

export const FeaturedCategoriesSkeleton = () => {
  return (
    <section className="featured-categories padding-top padding-bottom">
      <div className="container">
        <div className="section-header">
          <div className="section-header__content">
            <h2
              className="placeholder "
              style={{
                width: '350px',
                height: '16px',
                borderRadius: '24px',
              }}
            ></h2>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '16px', overflow: 'hidden' }}>
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="placeholder-glow bg-light"
              style={{ minWidth: '180px', flexShrink: 0 }}
            >
              <div
                className="placeholder "
                style={{
                  width: '180px',
                  height: '180px',
                  borderRadius: '24px',
                }}
              ></div>
              <div
                className="placeholder "
                style={{ height: '24px', marginTop: '8px' }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
